<template>
  <v-container fluid class="pa-0">
    <Layout :hidePreview="$route.params.machineId === undefined"
      :hideFilter="$route.query[pk + 'filter'] === undefined">

      <!-- no filters or sorting -->

      <template v-slot:list :pk="pk">
        <ListPane :getListMethod="GetJobStatusMap" :optional-filters="filters" :paginationEnabled="false"
          :show-filter-tab="false" :show-sorting-tab="false" :showSearch="false" :showClearFilter="false" ref="ListPane"
          :pk="pk">

          <template v-slot:list-item="{ item }">
            <ListItem :item="item" @edit="e => setEditItem(e)">
            </ListItem>
          </template>

        </ListPane>
      </template>
    </Layout>

    <EditJobStatusDialog :externaltrigger="dialogtrigger" :item="editItem" @Update="handleUpdate">
    </EditJobStatusDialog>
  </v-container>
</template>


<script>
import clientAPI from "@/api/ClientAPIMixin.js";
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";
import ListPane from "@/components/Sections/Panes/ListPane.vue";
import Layout from "@/views/layouts/PreviewableList.vue";
import ListItem from "@/components/ListItems/JobStatusListItem.vue";
import EditJobStatusDialog from "@/components/Dialogs/EditJobStatusDialog.vue";

export default {
  name: "AdminJobStatusList",
  props: {},
  components: {
    ListPane,
    Layout,
    ListItem,
    EditJobStatusDialog,
  },
  mixins: [clientAPI, FilterQueryMixin],

  data() {
    return {
      pk: "ATL-",
      editItem: null,
      dialogtrigger: 1,
    };
  },

  methods: {
    handleUpdate() {
      this.$refs.ListPane.fetch();
      this.$store.dispatch("BackgroundUpdater/Checker", "StatusMap");
    },

    setEditItem(item) {
      //console.log('setEditItem', item);
      this.editItem = item;
      this.dialogtrigger++;
    },
  },

  computed: {
    filters() {
      if (this.$route.query && Object.keys(this.$route.query).some((x) => x.includes(this.pk + "filter-"))) {
        var filters = {
          SearchWord: this.getQueryParam("filter-keyword", undefined),
        };
        return filters;
      }
      else {
        return null;
      }
    },

    externaltrigger() { return this.$store.state.triggerevents.previewTrigger; },
  },

  watch: {
    externaltrigger: function () { this.setEditItem(null); }
  },
};
</script>


<style lang='scss' scoped></style>